<template>
  <!--<div v-if="!id||review.review_id">-->
  <div>
    <template v-if="error">
      <div class="alert alert-danger alert-dismissable">
        <p>{{error}}</p>
      </div>
    </template>
    <template v-if="!error">
      <div class="alert alert-info alert-dismissable" v-if="message">
        <p>{{message}}</p>
      </div>
      <div class="alert alert-danger alert-dismissable" v-if="Object.keys(errors).length">
        <template v-for="error in errors">
          <p v-for="v in error">{{v}}</p>
        </template>
      </div>
      <div class="row col-sm-12">
        <div class="pull-right" v-if="!review.deleted_at">
          <!--<button class="btn btn-danger" v-on:click="showQuitModal">退会する</button>-->
        </div>
      </div>
      <text-group :label="'口コミ番号'" :val="review.review_id" :readonly="true" v-if="id"/>
      <text-group :label="'口コミ番号'" val="新規発番" :readonly="true" v-if="!id"/>

      <text-group
        v-if="review.member_id"
        :label="'会員'"
        :val="review.member_id"
        :readonly="true"/>


      <text-group
        v-if="review.created_at"
        :label="'登録日時'"
        :readonly="true"
        :val="review.created_at">
      </text-group>


      <text-group :label="'公開/非公開'"
                  :require="true">
        <template slot="text">
          <select class="form-control" v-model="review.is_public">
            <template v-for="tag in {0:{tag_value:'0',tag_name:'非公開'},1:{tag_value:'1',tag_name:'公開'}}">
              <option :value="tag.tag_value">{{tag.tag_name}}</option>
            </template>
          </select>
        </template>
      </text-group>
      <template v-if="review.company">
        <text-group :label="'連携企業'"
                    :val="review.company.name"
                    :readonly="true"
                    ></text-group>

      </template>
      <text-group :label="'企業名'"
                  v-model="review.company_name"
                  :val="review.company_name"
                  :require="true"></text-group>
      <text-group :label="''">
        <template slot="text">
          <router-link :to="`/company/review/check?review_id=${review.review_id}`">※ 連携会社を更新する</router-link>
        </template>
      </text-group>


      <text-group :label="'ホームページURL'"
                  v-model="review.company_url"
                  :val="review.company_url"
                  :require="true"></text-group>

      <text-group :label="'常駐/自社'"
                  :require="true">
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.working_space_id">
            <label class="radioMargin">
              <input type="radio" name="working_space_id" :value="tag.tag_value" v-model="review.working_space_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'当時のステータス'"
                  :require="true">
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.employment_id">
            <label class="radioMargin">
              <input type="radio" name="employment_id" :value="tag.tag_value" v-model="review.employment_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>


      <text-group
        :label="'参画時の精算幅'"
        v-model="review.project_contract_time"
        :val="review.project_contract_time"
        :require="true">
      </text-group>


      <text-group :label="'最寄駅'"
                  v-model="review.company_station"
                  :val="review.company_station"
                  :require="true"></text-group>


      <text-group :label="'案件名'"
                  v-model="review.project_title"
                  :val="review.project_title"
                  :require="true"></text-group>


      <text-group :label="'就業時間'"
                  v-model="review.project_working_time"
                  :val="review.project_working_time"
                  :require="true"></text-group>


      <text-group :label="'上記案件に関わった人数'"
                  v-model="review.project_member_num"
                  :val="review.project_member_num"
                  :require="true"></text-group>

      <text-group :label="'上記案件に関わった時期'"
                  v-model="review.project_attach_season"
                  :val="review.project_attach_season"
                  :require="true"></text-group>


      <text-group :label="'職種'"
                  :require="true">
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.occupation_id">
            <label class="radioMargin">
              <input type="checkbox" name="occupation_id" :value="tag.tag_value" v-model="review.occupation_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'言語'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.language_id">
            <label class="radioMargin">
              <input type="checkbox" name="language_id" :value="tag.tag_value" v-model="review.language_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'フレームワーク'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.framework_id">
            <label class="radioMargin">
              <input type="checkbox" name="framework_id" :value="tag.tag_value" v-model="review.framework_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>


      <text-group :label="'アプリ/ツール/CMS類 （開発系）'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.develop_tool_id">
            <label class="radioMargin">
              <input type="checkbox" name="develop_tool_id" :value="tag.tag_value" v-model="review.develop_tool_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'アプリ/ツール類 （テスト/他）'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.test_tool_id">
            <label class="radioMargin">
              <input type="checkbox" name="test_tool_id" :value="tag.tag_value" v-model="review.test_tool_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'アプリ/ツール類 （デザイン/他）'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.design_tool_id">
            <label class="radioMargin">
              <input type="checkbox" name="design_tool_id" :value="tag.tag_value" v-model="review.design_tool_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'アプリ/ツール類 （管理系、その他一般）'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.manager_tool_id">
            <label class="radioMargin">
              <input type="checkbox" name="manager_tool_id" :value="tag.tag_value" v-model="review.manager_tool_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'アプリ/ツール類 （ERP、RPA他系）'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.erp_tool_id">
            <label class="radioMargin">
              <input type="checkbox" name="erp_tool_id" :value="tag.tag_value" v-model="review.erp_tool_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'アプリ/ツール類 （BI/データ分析系）'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.bi_tool_id">
            <label class="radioMargin">
              <input type="checkbox" name="bi_tool_id" :value="tag.tag_value" v-model="review.bi_tool_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'サーバー/OS'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.os_id">
            <label class="radioMargin">
              <input type="checkbox" name="os_id" :value="tag.tag_value" v-model="review.os_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'クラウド'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.cloud_id">
            <label class="radioMargin">
              <input type="checkbox" name="cloud_id" :value="tag.tag_value" v-model="review.cloud_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>


      <text-group :label="'仮想環境'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.virtual_id">
            <label class="radioMargin">
              <input type="checkbox" name="virtual_id" :value="tag.tag_value" v-model="review.virtual_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>


      <text-group :label="'ミドルウェア/他'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.middleware_id">
            <label class="radioMargin">
              <input type="checkbox" name="middleware_id" :value="tag.tag_value" v-model="review.middleware_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'DB'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.database_id">
            <label class="radioMargin">
              <input type="checkbox" name="database_id" :value="tag.tag_value" v-model="review.database_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <text-group :label="'Network'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.network_id">
            <label class="radioMargin">
              <input type="checkbox" name="network_id" :value="tag.tag_value" v-model="review.network_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>
      <text-group :label="'その他/キーワード'"
      >
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.other_skill_id">
            <label class="radioMargin">
              <input type="checkbox" name="other_skill_id" :value="tag.tag_value" v-model="review.other_skill_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>

      <div class="panel panel-info  row">
        <p class="panel-body text-center">
          一番近い部分にチェックを入れてください。
        </p>
      </div>
      <hr class="hr-line-dashed">
      <!--  5段階 -->
      <text-group :label="'収入の満足度'"
                  :require="true">
        <template slot="text">
          <review-evaluation-type1 :rank.sync="review.rank_good_salary" class="mod_listbox" :title="false">
            <template slot="rank1">低い</template>
            <template slot="rank2">やや低い</template>
            <template slot="rank3">普通</template>
            <template slot="rank4">やや高い</template>
            <template slot="rank5">高い</template>
          </review-evaluation-type1>
        </template>
      </text-group>

      <text-group :label="'残業の多さ'"
                  :require="true">
        <template slot="text">
          <review-evaluation-type1 :rank.sync="review.rank_overwork" class="mod_listbox" :title="false">
            <template slot="rank1">多い</template>
            <template slot="rank2">やや多い</template>
            <template slot="rank3">普通</template>
            <template slot="rank4">少なめ</template>
            <template slot="rank5">ほぼ無し</template>
          </review-evaluation-type1>
        </template>
      </text-group>


      <text-group :label="'雰囲気（仕事のやりやすさ）'"
                  :require="true">
        <template slot="text">
          <review-evaluation-type1 :rank.sync="review.rank_good_team_mood" class="mod_listbox" :title="false">
            <template slot="rank1">やりにくい</template>
            <template slot="rank2">少しやりにくい</template>
            <template slot="rank3">普通</template>
            <template slot="rank4">少しやりやすい</template>
            <template slot="rank5">やりやすい</template>
          </review-evaluation-type1>
        </template>
      </text-group>

      <text-group :label="'仕事のやりがい・達成感'"
                  :require="true">
        <template slot="text">
          <review-evaluation-type1 :rank.sync="review.rank_good_reward" class="mod_listbox" :title="false">
            <template slot="rank1">感じなかった</template>
            <template slot="rank2">やや感じなかった</template>
            <template slot="rank3">普通</template>
            <template slot="rank4">やや感じた</template>
            <template slot="rank5">感じた</template>
          </review-evaluation-type1>

        </template>
      </text-group>

      <text-group :label="'PC環境'"
                  :require="true">
        <template slot="text">
          <review-evaluation-type1 :rank.sync="review.rank_good_pc_performance" class="mod_listbox" :title="false">
            <template slot="rank1">スペックが低い</template>
            <template slot="rank2">スペックが少し低い</template>
            <template slot="rank3">普通</template>
            <template slot="rank4">少しハイスペック</template>
            <template slot="rank5">ハイスペック</template>
          </review-evaluation-type1>
        </template>
      </text-group>


      <text-group :label="'業務の忙しさ'"
                  :require="true">
        <template slot="text">
          <review-evaluation-type2 :rank.sync="review.rank_busy" class="mod_listbox" :title="false">
            業務の忙しさ
            <template slot="low">暇</template>
            <template slot="high">忙しい</template>
          </review-evaluation-type2>
        </template>
      </text-group>
      <text-group :label="'社風'"
                  :require="true">
        <template slot="text">
          <review-evaluation-type2 :rank.sync="review.rank_good_corporate_culture" class="mod_listbox" :title="false">
            <template slot="low">堅実</template>
            <template slot="high">挑戦的</template>
          </review-evaluation-type2>
        </template>
      </text-group>
      <text-group :label="'ソフト・言語・ツール等'"
                  :require="true">
        <template slot="text">
          <review-evaluation-type2 :rank.sync="review.rank_good_tool" class="mod_listbox" :title="false">
            <template slot="low">古い</template>
            <template slot="high">新しい</template>
          </review-evaluation-type2>
        </template>
      </text-group>

      <text-group :label="'あてはまる条件にチェックを入れてください'"
                  :require="true">
        <template slot="text">
          <template v-for="tag in this.$store.state.tags.strong_point_id">
            <label class="radioMargin">
              <input type="checkbox" name="strong_point_id" :value="tag.tag_value" v-model="review.strong_point_id">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>
      <text-group :label="'口コミ情報'" :require="true">
        <template slot="text">
          <textarea class="form-control" rows="12" v-model="review.company_review"></textarea>
        </template>
      </text-group>

      <div class="panel panel-info  row">
        <p class="panel-body text-center">
          以下は常駐型フリーランスの方のみ、お答えください(非公開)
        </p>
      </div>

      <text-group :label="'エージェントの利用有無'"
                  :require="true">
        <template slot="text">
          <template
            v-for="tag in {0:{tag_value:'0',tag_name:'エージエントを利用していない'},1:{tag_value:'1',tag_name:'エージエントを利用した'}}">
            <div>
              <label class="radioMargin">
                <input type="radio" name="is_use_agent" :value="tag.tag_value" v-model="review.is_use_agent">
                {{tag.tag_name}}
              </label>
            </div>
          </template>
        </template>
      </text-group>


      <div v-for="(agent,key) in reviewAgents">
        <review-agent
          :index="key"
          :disable_check="!!((key+1)==reviewAgents.length)"
          :review_agent.sync="agent"
          @append="appendAgent"
          @delete="deleteAgent"
        ></review-agent>
      </div>


      <text-group :label="'現在もしくは今後、案件を紹介してほしいですか？'"
                  :require="true">
        <template slot="text">

          <template v-for="tag in this.$store.state.tags.is_need_job">
            <label class="radioMargin">
              <input type="radio" name="is_need_job" :value="tag.tag_value" v-model="review.is_need_job">
              {{tag.tag_name}}
            </label>
          </template>
        </template>
      </text-group>


      <div class="alert alert-danger alert-dismissable" v-if="validation">
        <template v-for="message in validation">
          <p v-if="message">{{message}}</p>
        </template>
      </div>
      <button class="btn btn-info" @click="updateReview" v-if="!isLock">保存</button>
      <button class="btn btn-default" v-if="isLock">保存中</button>
    </template>

  </div>
</template>
<script>
  import Api from '../../../service/Api.vue'
  import ReviewAgent from './Agent'
  import ReviewRank5 from './Rank5'
  import ReviewTags from './Tags'
  import ContractTime from '@/components/review/form/ContractTime'
  import ReviewValidate from '@/service/validate/Review.vue'
  import ReviewEvaluationType1 from '@/components/review/form/EvaluationType1'
  import ReviewEvaluationType2 from '@/components/review/form/EvaluationType2'

  export default {
    props: [
      'id'
    ],
    data () {
      return {
        uid: '',
        isModal: false,
        message: '',
        errors: [],
        error: '',
        tags: [],
        isLock: false,
        validation: false,
        review: {
          review_id: '',
          member_id: '',
          company_name: '',
          company_url: '',
          company_station: '',
          company_review: '',
          working_space_id: '1',
          employment_id: '1',
          project_working_time: '',
          project_contract_time: '',
          project_title: '',
          project_member_num: '',
          project_attach_season: '',
          rank_good_salary: '3',
          rank_good_team_mood: '3',
          rank_good_reward: '3',
          rank_good_pc_performance: '3',
          rank_busy: '3',
          rank_overwork: '3',
          rank_good_corporate_culture: '3',
          rank_good_tool: '3',
          is_public: '0',
          is_use_agent: '0',
          is_need_job: '3',
          occupation_id: [],
          language_id: [],
          middleware_id: [],
          database_id: [],
          network_id: [],
          other_skill_id: [],
          strong_point_id: [],
          tool_id: [],
          framework_id: [],
          server_id: []
        },
        member: {},
        reviewAgents: [],
        reviewTags: {}
      }
    },
    created: function () {
      this.uid = this._uid
      if (this.id) {
        Api.review.get(this.id)
          .then(this.showSuccess)
      } else {
        this.review.member_id = this.$route.query.member_id
        Api.member.get(this.review.member_id)
          .then(this.responseMember)
          .catch(this.responseMemberError)
      }
      this.tags = this.$store.state.tags
    },
    watch: {
      'this.$store.state.tags': function () {
        this.tags = this.$store.state.tags
      },
      'review.is_use_agent': {
        handler: function (val, oldVal) {
          if (val.toString() === '1' && !this.reviewAgents.length) {
            this.reviewAgents.push({
              agent_name: '',
              rank_good_reward: '',
              agent_review: ''
            })
          }
          if (oldVal.toString() === '1' && val.toString() === '0') {
            this.reviewAgents = []
          }
        },
        deep: true
      }
    },
    methods: {
      responseMember: function (response) {
        this.member = response.data.member
      },
      responseMemberError: function (response) {
        this.error = '会員詳細から口コミを作成してください。'
      },
      showSuccess: function (response) {
        this.review = response.data.review
        var reviewAgents = []
        this.review.review_agents = this.review.review_agents || []
        this.review.review_agents.forEach(function (row) {
          reviewAgents.push(row)
        })
        this.reviewAgents = reviewAgents
        console.log(this.review.review_agents)
        console.log(this.reviewAgents)
      },
      showFailure: function (errors) {
        var data = errors.response.data
        this.errors = data.errors
      },
      updateReview: function () {
        if (!this.isValid) {
          return
        }
        this.isLock = true
        var data = this.review
        data.review_agents = this.reviewAgents
        if (this.id) {
          Api.review.put(this.id, data)
            .then(this.updateSuccess)
            .catch(this.updateFailure)
        } else {
          Api.review.post(data)
            .then(this.updateSuccess)
            .catch(this.updateFailure)
        }
      },
      updateSuccess: function () {
        this.isLock = false
        this.isModal = false
        this.errors = []
        if (this.id) {
          Api.review.get(this.id)
            .then(this.showSuccess)
          this.message = '会員を更新しました'
        } else {
          this.message = '会員を登録しました'
          var review = this.review
          Object.keys(review).forEach(function (key) {
            review[key] = ''
          })
          this.review = review
        }
      },
      updateFailure: function (errors) {
        this.isLock = false
        this.isModal = false
        var data = errors.response.data
        this.errors = data.errors
        this.message = ''
      },
      appendAgent: function () {
        this.reviewAgents.push({
          agent_name: '',
          rank_good_reward: 2,
          agent_review: ''
        })
        this.$emit('update:review_agents', this.agents)
      },
      deleteAgent: function (key) {
        this.reviewAgents.splice(key, 1)
        this.$emit('update:review_agents', this.agents)
      }
    },
    computed: {
      isValid: function () {
        var valid = true
        this.validation = ReviewValidate.validate(this.review)
        for (var key in this.validation) {
          if (this.validation[key] !== false) {
            valid = false
          }
        }
        if (valid) {
          this.validation = false
        }
        return valid
      }
    },
    components: {
      ReviewRank5,
      ReviewTags,
      ReviewAgent,
      ReviewEvaluationType1,
      ReviewEvaluationType2,
      ContractTime
    }
  }
</script>

<style lang="scss">
  .radioMargin {
    margin-right: 20px;
  }

  .list {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// Form.vue?3826ac5f